import { Link } from "react-router-dom";
import { Gift } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { analytics } from "@/lib/utils";

export default function FreePassScrollPopup({ open, onOpenChange }) {
  const handleOpenChange = (val) => {
    if (!val) analytics.track("free_pass_popup_dismiss");
    onOpenChange(val);
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-[calc(100vw-2rem)] sm:max-w-md bg-white border-0 shadow-2xl p-5 sm:p-6">
        <DialogHeader className="text-center sm:text-center">
          <div className="w-14 h-14 sm:w-16 sm:h-16 mx-auto mb-3 sm:mb-4 rounded-full bg-brand-orange/10 flex items-center justify-center">
            <Gift className="w-7 h-7 sm:w-8 sm:h-8 text-brand-orange" />
          </div>
          <DialogTitle className="text-xl sm:text-2xl font-heading font-bold text-gray-900 uppercase tracking-wider">
            Try Us Free!
          </DialogTitle>
          <DialogDescription className="text-gray-600 text-sm sm:text-base mt-2">
            Experience Giant Fitness with a free day pass. No commitment, no pressure — just come see what we're all about.
          </DialogDescription>
        </DialogHeader>
        <div className="flex flex-col gap-3 mt-3 sm:mt-4">
          <Link to="/free-pass" onClick={() => onOpenChange(false)}>
            <Button className="w-full h-11 sm:h-12 bg-brand-orange hover:bg-brand-orange-hover text-white font-bold uppercase tracking-wider text-sm sm:text-base shadow-soft hover:shadow-neon-orange transition-all">
              Get Your Free Pass
            </Button>
          </Link>
          <Button
            variant="ghost"
            className="w-full text-gray-500 hover:text-gray-700 text-sm"
            onClick={() => onOpenChange(false)}
          >
            Maybe Later
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
